
export const USER_ROLE_ADMINISTRATOR = 'administrator';
export const USER_ROLE_CONTRIBUTOR = 'contributor';
export const USER_ROLE_READER = 'reader';
